"use client";

import { useEffect, useSyncExternalStore } from "react";

import {
  readClientLastSeenUpdateId,
  shouldShowUpdatesBanner,
  writeClientLastSeenUpdateId,
} from "#/lib/updatesSeen";

type UseUpdatesBannerVisibilityOptions = {
  latestUpdateId: string;
  serverLastSeenUpdateId: string | null;
};

function subscribeLastSeenUpdateId(onStoreChange: () => void) {
  window.addEventListener("storage", onStoreChange);
  return () => window.removeEventListener("storage", onStoreChange);
}

function getServerLastSeenSnapshot(): string | null {
  return null;
}

export function useUpdatesBannerVisibility({
  latestUpdateId,
  serverLastSeenUpdateId,
}: UseUpdatesBannerVisibilityOptions): { visible: boolean } {
  const clientLastSeenUpdateId = useSyncExternalStore(
    subscribeLastSeenUpdateId,
    readClientLastSeenUpdateId,
    getServerLastSeenSnapshot,
  );

  useEffect(() => {
    if (serverLastSeenUpdateId) {
      writeClientLastSeenUpdateId(serverLastSeenUpdateId);
    }
  }, [serverLastSeenUpdateId]);

  return {
    visible: shouldShowUpdatesBanner({
      latestUpdateId,
      lastSeenUpdateId: serverLastSeenUpdateId ?? clientLastSeenUpdateId,
    }),
  };
}
